import { useCallback, useState } from 'react';

// Same choice for every player of the webapp (feed, ranking), kept by the browser.
const MUTED_KEY = 'feedMuted';

const getSavedMuted = () => {
  try {
    return localStorage.getItem(MUTED_KEY) !== 'false';
  } catch (e) {
    return true;
  }
};

const usePlayerMuted = () => {
  const [muted, setMuted] = useState(getSavedMuted);

  const onToggleMute = useCallback(() => {
    setMuted((prev) => {
      try {
        localStorage.setItem(MUTED_KEY, String(!prev));
      } catch (e) {
        // Blocked storage: the choice is only kept for this visit.
      }
      return !prev;
    });
  }, []);

  // Muted by the browser, not by the user: the state follows, the saved choice doesn't change.
  const onForcedMute = useCallback(() => {
    setMuted(true);
  }, []);

  return { muted, onForcedMute, onToggleMute };
};

export default usePlayerMuted;
